import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Approval module.
 */
export const APPROVAL_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/approval/check-hours',
    labelKey: 'Approval.checkHours',
    icon: '/assets/tablerIcons/outline/clock-check.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalHours'
  },
  {
    path: '/approval/overview',
    labelKey: 'Approval.overview',
    icon: '/assets/tablerIcons/outline/eye.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalHours'
  },
  {
    path: '/approval/overall-approval',
    labelKey: 'Approval.overallApproval',
    icon: '/assets/tablerIcons/outline/check.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalHours'
  },
  {
    path: '/approval/working-time-compliance',
    labelKey: 'Approval.workingTimeCompliance',
    icon: '/assets/tablerIcons/outline/scale.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalHours'
  },
  {
    path: '/approval/personal-message',
    labelKey: 'Approval.personalMessage',
    icon: '/assets/tablerIcons/outline/message.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalCommunication'
  },
  {
    path: '/approval/advance-registration',
    labelKey: 'Approval.advanceRegistration',
    icon: '/assets/tablerIcons/outline/calendar-plus.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalAdmin'
  },
  {
    path: '/approval/administration-time-bank',
    labelKey: 'Approval.administrationTimeBank',
    icon: '/assets/tablerIcons/outline/wallet.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalAdmin'
  },
  {
    path: '/approval/export-hours',
    labelKey: 'Approval.exportHours',
    icon: '/assets/tablerIcons/outline/file-export.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalAdmin'
  },
  {
    path: '/approval/timer-aktivering',
    labelKey: 'Approval.timerAktivering',
    icon: '/assets/tablerIcons/outline/clock-bolt.svg',
    moduleId: 18,
    groupLabelKey: 'MenuRoutes.group.approvalAdmin'
  }
];
